import { z } from 'zod';
import { chassisNumber } from '../../../../common/validation/Validations';
import { VinAssignmentStatus } from '../../../../generated/ApiClient';

export const validPrintStatus = [
  VinAssignmentStatus.Submitted,
  VinAssignmentStatus.HandOverPrinting,
];

const handOverPositionSchema = z
  .object({
    position: z.number(),
    vin: chassisNumber.optional().nullable(),
    cmsId: z.string(),
    status: z.nativeEnum(VinAssignmentStatus),
    selected: z.boolean(),
  })
  .refine((x) => (x.selected ? !!x.vin : true), {
    path: ['vin'],
  });

export const handOverPositionsSchema = z.object({
  positions: z.array(handOverPositionSchema),
});

export type HandOverPositionsValues = z.infer<typeof handOverPositionsSchema>;
export type HandOverValue = z.infer<typeof handOverPositionSchema>;
